__turbopack_context__.v({
  "action": "Umy6Ma_action",
  "articles": "Umy6Ma_articles",
  "card": "Umy6Ma_card",
  "imageContainer": "Umy6Ma_imageContainer",
  "publishDate": "Umy6Ma_publishDate",
  "root": "Umy6Ma_root",
  "summary": "Umy6Ma_summary",
  "title": "Umy6Ma_title",
});
